import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f816346e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=f816346e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f816346e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f816346e')) {
      api.createRecord('f816346e', component.options)
    } else {
      api.reload('f816346e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f816346e&scoped=true&", function () {
      api.rerender('f816346e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HtHistoryRecorder/index.vue"
export default component.exports